import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2955_8102",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 4,
		y: 4,
		width: 25,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 24.0039,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2955_8102)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16.0016 21C16.285 21 16.5225 20.9042 16.7142 20.7125C16.9059 20.5208 17.0018 20.2833 17.0018 20C17.0018 19.7167 16.9059 19.4792 16.7142 19.2875C16.5225 19.0958 16.285 19 16.0016 19C15.7182 19 15.4807 19.0958 15.289 19.2875C15.0973 19.4792 15.0015 19.7167 15.0015 20C15.0015 20.2833 15.0973 20.5208 15.289 20.7125C15.4807 20.9042 15.7182 21 16.0016 21ZM16.0016 17C16.285 17 16.5225 16.9042 16.7142 16.7125C16.9059 16.5208 17.0018 16.2833 17.0018 16V12C17.0018 11.7167 16.9059 11.4792 16.7142 11.2875C16.5225 11.0958 16.285 11 16.0016 11C15.7182 11 15.4807 11.0958 15.289 11.2875C15.0973 11.4792 15.0015 11.7167 15.0015 12V16C15.0015 16.2833 15.0973 16.5208 15.289 16.7125C15.4807 16.9042 15.7182 17 16.0016 17ZM16.0016 26C14.6181 26 13.3179 25.7375 12.101 25.2125C10.8841 24.6875 9.82562 23.975 8.92548 23.075C8.02533 22.175 7.31271 21.1167 6.78763 19.9C6.26254 18.6833 6 17.3833 6 16C6 14.6167 6.26254 13.3167 6.78763 12.1C7.31271 10.8833 8.02533 9.825 8.92548 8.925C9.82562 8.025 10.8841 7.3125 12.101 6.7875C13.3179 6.2625 14.6181 6 16.0016 6C17.3852 6 18.6854 6.2625 19.9023 6.7875C21.1191 7.3125 22.1776 8.025 23.0778 8.925C23.9779 9.825 24.6905 10.8833 25.2156 12.1C25.7407 13.3167 26.0033 14.6167 26.0033 16C26.0033 17.3833 25.7407 18.6833 25.2156 19.9C24.6905 21.1167 23.9779 22.175 23.0778 23.075C22.1776 23.975 21.1191 24.6875 19.9023 25.2125C18.6854 25.7375 17.3852 26 16.0016 26Z",
			fill: "white"
		})
	})]
});
export default SvgError;
